import React from "react";
import { Check } from "lucide-react";
import "../../styles/SharedStates.css";

export default function EmptyState({ icon: Icon = Check, title, description, action, compact = false, className = "" }) {
  return (
    <div className={`admin-empty-state ${compact ? "admin-empty-state--compact" : ""} ${className}`.trim()} role="status">
      <span className="admin-empty-state__icon"><Icon aria-hidden="true" /></span>
      {title && <h3>{title}</h3>}
      {description && <p>{description}</p>}
      {action && <div className="admin-empty-state__action">{action}</div>}
    </div>
  );
}
